import SummaryContent from '@/components/booking-summary/SummaryContent';
import { ChangeBookingSummaryRows } from '@/components/manage/change-trips/ChangeBookingSummaryRows';
import PriceDisplay from '@/components/PriceDisplay';
import type { BookingSummaryData } from '@/hooks/useBookingSummaryData';
import { useChangeBookingSelection } from '@/hooks/useChangeBookingSelection';
import { useChangeTotal } from '@/hooks/useChangeTotal';
import { TransText } from '@/i18n/trans/text';
import {
  Button,
  Divider,
  Icons,
  Sheet,
  Typography,
} from '@packages/webshop-design-system';
import type { FC } from 'react';

const MobileBookingSummary: FC<BookingSummaryData> = ({
  displayPrice,
  ...props
}) => {
  const { hasSelection } = useChangeBookingSelection();
  const changeTotal = useChangeTotal();
  return (
    <Sheet
      trigger={
        <Button
          variant="ghost"
          data-testid="booking-summary-trigger"
          className="flex h-auto w-full flex-row items-center justify-between rounded-none bg-white"
        >
          <div className="flex flex-row items-center gap-2">
            <Icons.travelPass className="h-4 w-4 text-primary" />
            <Typography variant="body1-bold">
              <TransText i18nKey="bookingSummary" />
            </Typography>
          </div>
          <div className="flex flex-row items-center gap-1 text-primary">
            <Typography variant="body2-bold">
              {hasSelection ? (
                changeTotal
              ) : (
                <PriceDisplay amount={displayPrice?.amount} />
              )}
            </Typography>
            <Icons.chevronUp className="h-4 w-4" />
          </div>
        </Button>
      }
      side="bottom"
      headerIcon={<Icons.travelPass className="h-5 w-5 text-primary" />}
      headerTitle={<TransText i18nKey="bookingSummary" />}
      className={{ content: 'p-0' }}
      data-testid="booking-summary-content"
    >
      <Divider variant="medium" />
      <div className="max-h-[calc(100vh-170px)] overflow-y-auto">
        <SummaryContent {...props} />
      </div>
      {hasSelection && <ChangeBookingSummaryRows />}
      <Divider variant="medium" className="border-primary" />
      <div className="flex flex-row justify-between p-4">
        <div className="flex gap-2">
          <Icons.shoppingCart className="text-primary" />
          <Typography variant="body1-bold">
            <TransText i18nKey={hasSelection ? 'changeTotal' : 'totalPrice'} />
          </Typography>
        </div>
        <Typography variant="body1-bold" className="text-primary">
          {hasSelection ? (
            changeTotal
          ) : (
            <PriceDisplay amount={displayPrice?.amount} />
          )}
        </Typography>
      </div>
    </Sheet>
  );
};

export default MobileBookingSummary;
